import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Project } from '@src/app/models/project';
import { ProjectdeleteService } from './service/projectdelete.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-projectdelete',
  templateUrl: './projectdelete.component.html',
  styleUrls: ['./projectdelete.component.css']
})
export class ProjectdeleteComponent implements OnChanges {
  @Input() project: Project;
  toDelete: Project;
  showSpinner: boolean;
  showmsg: boolean = false;
  @ViewChild('closeconfirm', { static: true }) closeconfirm: ElementRef;
  @Output() projectDeleted = new EventEmitter<Project>();

  projectlist: any;
  constructor(private pdsrv: ProjectdeleteService) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.project && changes.project.currentValue != undefined) this.toDelete = changes.project.currentValue;
  }

  deleteProject() {
    this.showSpinner = true;
    if (this.toDelete) {
      //delete from db
      this.pdsrv.deleteProject(this.toDelete).pipe(untilDestroyed(this)).subscribe(res => {
        //console.log('project deleted', res);
        //remove from UI
        this.projectDeleted.emit(this.toDelete);
        this.toDelete = undefined;
        this.showSpinner = false;
        this.showmsg = true;
        setTimeout(() => {
          this.closeconfirm.nativeElement.click();
          setTimeout(() => {
            this.reset()
          }, 100);
        }, 100);
      });
    }

  }

  reset() {
    this.showSpinner = false;
    this.showmsg = false;
  }
}

